module.exports = __webpack_public_path__ + "media/assets/Checked-5f7664e0626edd13da1a5cd2c5539a23.svg";